module.exports = __webpack_public_path__ + "img/ZZRY_11.2234554f.jpg";